import { StockItemFragment } from "generated/graphql";

export const getMedicineSpeciesAsString = (species: StockItemFragment["species"]) =>
  species.map((item) => item.name).join(", ");
